import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { MemberNetworkModel } from './models/member-network.model';

export interface MemberNetworkState extends EntityState<MemberNetworkModel> { }

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'network', idKey: 'RelationshipId' })
export class MemberNetworkStore extends EntityStore<MemberNetworkState> {

  constructor() {
    super();
  }

}
